module.exports = __webpack_public_path__ + "img/子岸镇-c.7ec3c96f.png";